import addDays from 'date-fns/addDays';
import { FC } from 'react';

import { useShowWarnByActiveStatus } from '@/components/modules/orders-page/orders/hooks/use-show-warn-by-active-status';
import { Court } from '@/components/modules/orders-page/orders/ui/court';
import { EOrderStatus, TOrder } from '@/types/orders';

import { useTranslate } from '@/shared/hooks/use-translate';

import { getUiConfig } from '../../../utils/get-ui-config';
import { Body } from '../body';
import { Header } from '../header';

import * as Styled from './styled';

type TProps = {
    order: TOrder;
};

export type TProductItemConfig = {
    status: EOrderStatus;
    termUnit: 1 | 2 | undefined;
    isBuyout: boolean;
};

export const ProductItem: FC<TProps> = ({ order }) => {
    const { t } = useTranslate();

    const config = getUiConfig(order);

    const WarningStatusComponent = useShowWarnByActiveStatus({
        orderStatusTime: order.status.time,
        t,
        status: config.status,
    });

    const returned =
        config.status === EOrderStatus.Active
            ? addDays(new Date(order.create_date), order.params.terms.requested)
            : order.terms.return_date;

    const photo = Array.isArray(order?.rentProduct?.presentation_photos)
        ? order.rentProduct.presentation_photos.find((img) => img.isMain)
        : null;

    const pathToProduct = `/product/${order.rentProduct.id}`;

    return (
        <Styled.Wrapper>
            <Header photo={photo} returned={returned} config={config} pathToProduct={pathToProduct} order={order} />
            <Body photo={photo} returned={returned} config={config} pathToProduct={pathToProduct} order={order} />
            <WarningStatusComponent />

            {config.status === EOrderStatus.Sent_to_court && <Court order={order} />}
        </Styled.Wrapper>
    );
};
